var moreText = "Click here to read more about us",
lessText = "Hide additional information",
moreButton = $(".read_more_trigger");
moreButton.click(function (e) {
    e.preventDefault();
    var $this = $(this);
    $this.text($this.text() == moreText ? lessText : moreText);
    $(".extra_txt").slideToggle("fast");
});